import { render, staticRenderFns } from "./AppTabbar.vue?vue&type=template&id=ffcb16d6&scoped=true&"
import script from "./AppTabbar.vue?vue&type=script&lang=js&"
export * from "./AppTabbar.vue?vue&type=script&lang=js&"
import style0 from "./AppTabbar.vue?vue&type=style&index=0&id=ffcb16d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcb16d6",
  null
  
)

export default component.exports